import { AUTH_ORG_QUERY_PARAM_NAME } from '../../auth/authConsts';

export const createAccountUrl = (
  authZeroOrgId: string,
  fullName?: string,
  skipAccountCreation?: boolean,
) => {
  return (
    window.location.origin +
    '?' +
    AUTH_ORG_QUERY_PARAM_NAME +
    '=' +
    authZeroOrgId +
    (fullName ? '&fullName=' + fullName : '') +
    (skipAccountCreation ? '&skipAccountCreation=true' : '')
  );
};
